<template>
  <div id="app">
    <v-app>


      <v-navigation-drawer
        v-model="drawer"
        absolute
        style="position:fixed; top:0; left:0; overflow-y:scroll;"
        temporary>
        <v-list nav dense>

        
          <v-list-item href="./research">
            <v-list-item-icon>
              <v-icon>mdi-feature-search-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Research</v-list-item-title>
          </v-list-item>

          <v-list-item href="./CV.pdf">
            <v-list-item-icon>
              <v-icon>mdi-file-account</v-icon>
            </v-list-item-icon>
            
            <v-list-item-title>CV</v-list-item-title>
            
          </v-list-item>

          <v-list-item href="./projects">
            <v-list-item-icon>
              <v-icon>mdi-tools</v-icon>
            </v-list-item-icon>
            
            <v-list-item-title>Projects</v-list-item-title>
            
          </v-list-item>

          <v-list-item href="./interests">
            <v-list-item-icon>
              <v-icon>mdi-heart</v-icon>
            </v-list-item-icon>
            
            <v-list-item-title>Interests</v-list-item-title>
            
          </v-list-item>

          <v-list-item href="./blog">
            <v-list-item-icon>
              <v-icon>mdi-chat</v-icon>
            </v-list-item-icon>
            
            <v-list-item-title>Blog</v-list-item-title>
            
          </v-list-item>

        </v-list>
      </v-navigation-drawer>

      <v-app-bar 
        app
        color="#4C6665"
        height="100"
        scroll-threshold='5'
        clipped-right
        elevation="0">
        <a href = './'><v-avatar

          class="mr-3"
          color="#4C6665"
          size="70"
        >
          <v-img
            contain
            max-height="70%"
            src="@/assets/logo.png"
          ></v-img>
        </v-avatar></a>
        
        <v-spacer></v-spacer>

        <v-btn title="Research" href='./research' v-if="$vuetify.breakpoint.mdOnly||$vuetify.breakpoint.lgOnly||$vuetify.breakpoint.xlOnly" icon style="color:white">
          <v-icon large>mdi-feature-search-outline</v-icon>
        </v-btn>
        <v-btn title="CV" href="./CV.pdf" v-if="$vuetify.breakpoint.mdOnly||$vuetify.breakpoint.lgOnly||$vuetify.breakpoint.xlOnly" icon style="color:white">
          <v-icon large>mdi-file-account</v-icon>
        </v-btn>
        <v-btn title="Projects" href='./projects' v-if="$vuetify.breakpoint.mdOnly||$vuetify.breakpoint.lgOnly||$vuetify.breakpoint.xlOnly" icon style="color:white">
          <v-icon large>mdi-tools</v-icon>
        </v-btn>
        <v-btn title="Interests" href="./interests" v-if="$vuetify.breakpoint.mdOnly||$vuetify.breakpoint.lgOnly||$vuetify.breakpoint.xlOnly" icon style="color:white">
          <v-icon large>mdi-heart</v-icon>
        </v-btn>
        <v-btn title="Blog" href='./blog' v-if="$vuetify.breakpoint.mdOnly||$vuetify.breakpoint.lgOnly||$vuetify.breakpoint.xlOnly" icon style="color:white">
          <v-icon large>mdi-chat</v-icon>
        </v-btn>
        <v-btn v-if="$vuetify.breakpoint.smOnly||$vuetify.breakpoint.xsOnly" icon style="color:white" @click="drawer = !drawer">
          <v-icon large>mdi-menu</v-icon>
        </v-btn>
        
        

      </v-app-bar>

      <v-content>
        
        <section style="background:#ffffff" id="about-me">
          <div class="py-4"></div>

          <v-container  class="text-center less-margin">
            <h2 class="display-2 black-text font-weight-bold mb-3">RESEARCH</h2>

            <v-responsive class="mx-auto mb-8" width="56">
              <v-divider class="mb-1"></v-divider>
              <v-divider></v-divider>
            </v-responsive>

            <v-row class='margin black-text cv' >
              <v-col cols="9">
                <h3 class="link-website bold"><a class="link-website bold" href='https://scholar.google.com/citations?user=iW2M5cwAAAAJ&hl=en' target='_blank'>Google Scholar</a></h3>                
              </v-col>
              <v-col cols="3">
                <div class="link-website2" itemscope itemtype="https://schema.org/Person">
                  <a class="link-website2 bold" itemprop="sameAs" content="https://orcid.org/0000-0001-7072-1522" href="https://orcid.org/0000-0001-7072-1522" target="orcid.widget" rel="me noopener noreferrer" style="vertical-align:top;">
                    <img src="https://orcid.org/sites/default/files/images/orcid_16x16.png" style="width:1em;margin-right:.5em;" alt="ORCID iD icon">ORCID
                  </a>
                </div>
              </v-col>
            </v-row>
            
            <v-row class='margin black-text cv' id='cv'>
              <v-col cols="12" sm='6'>
                <h2 class="titlee">Highlighted Publications</h2>                
              </v-col>
            </v-row>

            <v-row class='margin black-text cv' id='cv'>
              <v-col class="cv-text middle" cols="12" md='8'>   
                <h3 class='paper-title'><b style="font-weight:bold">Zhang Z^, Mille LS^</b>, Kaseniit KE, Call CC, Zhang M, Hu Y, Xie Y, Gao XJ*
                <a class="link" href="https://www.biorxiv.org/content/10.1101/2024.05.03.592453v1" target="_blank">Post-Transcriptional Modular Synthetic Receptors</a>.
                <b style="font-weight:bold">BioRxiv</b>, 2023.</h3>
              </v-col> 
              <v-col class="cv-text middle" cols="12" md='4'>   
                <v-img class="img" max-width="250px" gradient="to top, rgba(0,0,0,.0), rgba(25,32,72,.0)" 
                contain src='../../../public/LIDAR.jpg'></v-img>
              </v-col> 
            </v-row>

            <v-row class='margin black-text cv' id='cv'>
              <v-col class="cv-text middle" cols="12" md='8'>   
                <h3 class='paper-title'>Ahn Horst T, <b style="font-weight:bold">Mille LS</b>, Sun G, Morrison J, Covert MW*.
                <a class="link" href="https://www.nature.com/articles/s41540-022-00242-9" target="_blank">An expanded whole-cell model of E. coli links cellular physiology with mechanisms of growth rate control</a>.
                <b style="font-weight:bold">NPJ Systems Biology and Applications</b>, 2022, in press.</h3>
              </v-col> 
              <v-col class="cv-text middle" cols="12" md='4'>   
                <v-img class="img" max-width="250px" gradient="to top, rgba(0,0,0,.0), rgba(25,32,72,.0)" 
                contain src='../../../public/travis.webp'></v-img>
              </v-col> 
            </v-row>

            <v-row class='margin black-text cv' id='cv'>
              <v-col class="cv-text middle" cols="12" md='8'>   
                <h3 class='paper-title'>Liu Q, <b style="font-weight:bold">Mille LS</b>, Villalobos C, Anaya I ... Zhang YS*.
                <a class="link" href="https://link.springer.com/article/10.1007/s42242-022-00229-9" target="_blank">3D-bioprinted cholangiocarcinoma-on-a-chip model for evaluating drug responses</a>.
                <b style="font-weight:bold">Bio-Design and Manufacturing</b>, 2023, in press.</h3>
              </v-col> 
              <v-col class="cv-text middle" cols="12" md='4'>   
                <v-img class="img" max-width="250px" gradient="to top, rgba(0,0,0,.0), rgba(25,32,72,.0)" 
                contain src='../../../public/qiong.webp'></v-img>
              </v-col> 
            </v-row>

            <v-row class='margin black-text cv' id='cv'>
              <v-col class="cv-text middle" cols="12" md='8'>   
                <h3 class='paper-title'>Wang M, Li W, <b style="font-weight:bold">Mille LS</b>, Ching T, Luo Z, Tang G, Garciamendez CE, Lesha A, Hashimoto M, Zhang YS*.
                <a class="link" href="https://onlinelibrary.wiley.com/doi/full/10.1002/adma.202107038" target="_blank">Digital Light Processing-based Bioprinting with Composable Gradients</a>.
                <b style="font-weight:bold">Advanced Materials</b>, 2021, in press.</h3>
              </v-col> 
              <v-col class="cv-text middle" cols="12" md='4'>   
                <v-img class="img" max-width="250px" gradient="to top, rgba(0,0,0,.0), rgba(25,32,72,.0)" 
                contain src='https://firebasestorage.googleapis.com/v0/b/zhang-lab-570b6.appspot.com/o/publications%2FfqKIGkGQwo6S1INsfGiA?alt=media&token=f91e6b48-9f1c-4361-8aa5-afbd7b859d7c'></v-img>
              </v-col> 
            </v-row>

            <v-row class='margin black-text cv' id='cv'>
              <v-col class="cv-text middle" cols="12" md='8'>   
                <h3 class='paper-title'>Valverde M, <b style="font-weight:bold">Mille LS</b>, Figler K, Cervantes E, Li VY, Bonventre J*, Masereeuw R*, Zhang YS*.
                <a class="link" href="." target="_blank">The Glomerulus: A Review on Current Biomimetic Models</a>. 
                <b style="font-weight:bold">Nature Reviews Nephrology</b>, 2021, in press.</h3>
              </v-col> 
              <v-col class="cv-text middle" cols="12" md='4'>   
                <v-img class="img" max-width="250px" gradient="to top, rgba(0,0,0,.0), rgba(25,32,72,.0)" 
                contain src='https://firebasestorage.googleapis.com/v0/b/zhang-lab-570b6.appspot.com/o/publications%2F4HXssCcajuAMC9eduIqD?alt=media&token=4b57df23-1ab1-4fbb-a6ac-1fd11d6a2f11'></v-img>
              </v-col> 
            </v-row>

            <v-row class='margin black-text cv' id='cv'>
              <v-col class="cv-text middle" cols="12" md='8'>   
                <h3 class='paper-title'>Li W, Wang M, <b style="font-weight:bold">Mille LS</b>, Robledo JA, Huerta V, Uribe T, Cheng F, Li H, Gong J, Ching T, Murphy CA, Lesha A, Hassan S, Woodfield T, Lim KS*, Zhang YS*.
                <a class="link" href="https://onlinelibrary.wiley.com/doi/10.1002/adma.202102153" target="_blank">A Smartphone-Enabled Portable Digital Light Processing 3D Printer</a>. 
                <b style="font-weight:bold">Advanced Materials</b>, 2021, in press.</h3>
              </v-col> 
              <v-col class="cv-text middle" cols="12" md='4'>   
                <v-img class="img" max-width="250px" gradient="to top, rgba(0,0,0,.0), rgba(25,32,72,.0)" 
                contain src='https://firebasestorage.googleapis.com/v0/b/zhang-lab-570b6.appspot.com/o/publications%2FxeSx1onxMRxOrK4u6Wbf?alt=media&token=7926469f-fe3e-4394-a2cc-2386a0319761'></v-img>
              </v-col> 
            </v-row>

            <v-row class='margin black-text cv' id='cv'>
              <v-col class="cv-text middle" cols="12" md='8'>   
                <h3 class='paper-title'>Maharjan S, Alva J, Cámara C, Rubio AG, Hernández D, Delavaux C, Correa E, Romo MD, Bonilla D, <b style="font-weight:bold">Mille LS</b>, Li W, Cheng F, Ying G, Zhang YS*.
                <a class="link" href="https://www.cell.com/matter/fulltext/S2590-2385(20)30576-2" target="_blank"> Symbiotic Photosynthetic Oxygenation within 3D-Bioprinted Vascularized Tissues</a>. 
                <b style="font-weight:bold">Matter</b>, 2020, in press.</h3>
              </v-col> 
              <v-col class="cv-text middle" cols="12" md='4'>   
                <v-img class="img" max-width="250px" gradient="to top, rgba(0,0,0,.0), rgba(25,32,72,.0)" contain src='https://imgix.bustle.com/uploads/image/2020/11/16/739cac36-c01f-417a-941d-584bcc90892b-qcpb51aw-aglae.jpeg?w=710&h=710&auto=format%2Ccompress&cs=srgb&q=70&fit=max&crop=faces&dpr=2%22'></v-img>
              </v-col> 
            </v-row>

            <v-row class='margin black-text cv' id='cv'>
              <v-col class="cv-text middle" cols="12" md='8'>   
                <h3 class='paper-title'>Li W, <b style="font-weight:bold">Mille LS</b>, Robledo JA, Uribe T, Huerta V, Zhang YS*.
                <a class="link" href="https://onlinelibrary.wiley.com/doi/abs/10.1002/adhm.202000156" target="_blank">Recent Advances in Formulating and Processing Biomaterial Inks for Vat Polymerization-Based 3D Printing. </a> 
                <b style="font-weight:bold">Advanced Healthcare Materials</b>, 2020, in press.</h3>
              </v-col> 
              <v-col class="cv-text middle" cols="12" md='4'>   
                <v-img class="img" gradient="to top, rgba(0,0,0,.0), rgba(25,32,72,.0)" contain src='../../assets/1.jpg'></v-img>
              </v-col> 
              
            </v-row>

            <v-row class='margin black-text cv' id='cv'>
              <v-col class="cv-text middle" cols="12" md='8'>   
                <h3 class='paper-title'>Liu T, Liu Q, Anaya I, Huang D, Kong W, <b style="font-weight:bold">Mille LS</b>, Zhang YS*.
                <a class="link" href="https://www.sciencedirect.com/science/article/pii/S1046202320300475" target="_blank">Investigating Lymphangiogenesis in a Sacrificially Bioprinted Volumetric Model of Breast Tumor Tissue</a>. 
                <b style="font-weight:bold">Methods</b>, 2020, in press.</h3>
              </v-col> 
              <v-col class="cv-text middle" cols="12" md='4'>   
                <v-img class="img" gradient="to top, rgba(0,0,0,.0), rgba(25,32,72,.0)" contain src='../../assets/2.png'></v-img>
              </v-col> 
              
            </v-row>

            <div>
              <v-divider/>
            </div>

            <v-row class='margin black-text cv' id='cv'>
              <v-col cols="12" sm='4'>
                <h2 class="titlee">Conferences</h2>                
              </v-col>
            </v-row>

            <v-row class='margin black-text cv' id='cv'>
              <v-col class="cv-text middle" cols="12" md='8'>   
                <h3 class='paper-title'><b style="font-weight:bold">Mille LS^</b>, Zhang X^,
                    Kaseniit KE, Call CC, Zhang M, Hu Y, Xie Y, Gao XJ*
                  <a class="link" href="https://www.biorxiv.org/content/10.1101/2024.05.03.592453v1" target="_blank">
                    Post-Transcriptional Modular Synthetic Receptors</a>. Newry, Maine.<br> GRC Synthetic Biology 2023.
                </h3>
              </v-col> 
              <v-col class="cv-text middle" cols="12" md='4'>   
                <v-img class="img" max-width="250px" gradient="to top, rgba(0,0,0,.0), rgba(25,32,72,.0)" 
                contain src='../../../public/LIDAR.jpg'></v-img>
              </v-col> 
            </v-row>

            <v-row class='margin black-text cv' id='cv'>
              <v-col class="cv-text middle" cols="12" md='8'>   
                <h3 class='paper-title'><b style="font-weight:bold">Mille LS</b>,
                Li W, Robledo JA, Uribe T, Huerta V, Zhang YS*.
                <a class="link" target="_blank" href="https://firebasestorage.googleapis.com/v0/b/santimille.appspot.com/o/research%2Fluis_mille-poster.pdf?alt=media&token=ae50ade6-a2ea-44ad-b043-074f95beabad" >
                  Development of a Portable, Phone-Operated, and Cost-Effective Digital Light Processing (DLP) 3D Printer</a>.
                  Brigham and Women’s Hospital. Cambridge, MA. 2020.</h3>
                <i style="font-weight:bold">Virtual Presentation - Outstanding Presentation Award at SACNAS 2020</i>
                
              </v-col> 
              <v-col class="cv-text middle" cols="12" md='4'>   
                <a href="https://firebasestorage.googleapis.com/v0/b/santimille.appspot.com/o/research%2Fluis_mille-poster.pdf?alt=media&token=ae50ade6-a2ea-44ad-b043-074f95beabad"><v-img class="poster" lazy-src='../../assets/logo.png' contain src='@/assets/Picture1.png'></v-img></a>
              </v-col> 
            </v-row>
            
            <v-row class='margin black-text cv' id='cv'>
              <v-col class="cv-text middle" cols="12" md='8'>   
                <h3 class='paper-title'><b style="font-weight:bold">Mille LS</b>,
                Vazquez A, Oliva JL*, Garcia B, Vazquez EA.
                <a class="link" href="https://www-optica.inaoep.mx/~tecnologia_salud/2019/trabajos_cartel.php" target="_blank">Kidney-on-a-chip: Microfabrication and physiological microenviroment mimetism</a>. INAOE, Mexico, 2019.</h3>
                <i style="font-weight:bold">Lauded with Honorable Mention</i>
              </v-col> 
              <v-col class="cv-text middle" cols="12" md='4'>   
                <a href="https://storage.googleapis.com/santimille.appspot.com/research/lab.png"><v-img class="poster" lazy-src='../../assets/logo.png' contain src='https://storage.googleapis.com/santimille.appspot.com/research/lab.png'></v-img></a>
              </v-col> 
            </v-row>

            <v-row class='margin black-text cv' id='cv'>
              <v-col class="cv-text middle" cols="12" md='8'>   
                <h3 class='paper-title'><b style="font-weight:bold">Mille LS</b>,
                Ibarra CU, Fabian DA, Oliva JL*, Garcia B, Vazquez EA.
                <a class="link" href="https://www-optica.inaoep.mx/~tecnologia_salud/2019/trabajos_cartel.php" target="_blank">CytoDisc: Manufacturing of centrifugated microfluidics devices for cytotoxicity assays</a>. INAOE, Mexico, 2019.</h3>
              </v-col>
              <v-col class="cv-text middle" cols="12" md='4'>   
                <a href="https://storage.googleapis.com/santimille.appspot.com/research/cyto.png"><v-img class="poster" lazy-src='../../assets/logo.png' contain src='https://storage.googleapis.com/santimille.appspot.com/research/cyto.png'></v-img></a>
              </v-col> 
            </v-row>

            <v-row class='margin black-text cv' id='cv'>
              <v-col class="cv-text middle" cols="12" md='8'>   
                <h3 class='paper-title'>For the <a class="link" href="http://2018.igem.org/Team:TecCEM" target="_blank">2018 iGEM Competition </a> I collaborated in the development of TecTissue, a novel treatment that is capable of reducing wound healing time, preventing infections 
                and consequently, decreasing mortality rate.</h3>
                <i style="font-weight:bold">Gold medal and 4 special nominations.</i>
              </v-col> 
              <v-col class="cv-text middle" cols="12" md="4">   
                <a target="_blank" href="https://firebasestorage.googleapis.com/v0/b/santimille.appspot.com/o/research%2Figem.png?alt=media&token=3fe06ef2-7db5-4a35-a1d9-e738a27b4012">
                  <v-img class="poster" contain lazy-src='../../assets/logo.png' src='https://firebasestorage.googleapis.com/v0/b/santimille.appspot.com/o/research%2Figem.png?alt=media&token=3fe06ef2-7db5-4a35-a1d9-e738a27b4012'></v-img>
                </a>
              </v-col> 
            </v-row>
            

          </v-container>

          <div class="py-12"></div>
        </section>

      </v-content>

      <v-footer
        class="justify-center"
        color="#4C6665"
        height="100"
      >
        <div class="title font-weight-light grey--text text--lighten-1 text-center">
          &copy; {{ (new Date()).getFullYear() }} — Made with 💜 by Santiago Mille
        </div>
      </v-footer>
    </v-app>
  </div>
</template>

<script>
  export default {
    name: 'ResearchPage',

    data: () => ({
      
      drawer:false
    
    }),
    methods:{
      
    }
  }
</script>
<style scoped>
.color{
  background: #4C6665;
  min-width: 100vw;
  min-height: 130vh;
}
.H04F06A{
  color: #04F06A;
}
.HFF5D73{
  color: #FF5D73;
}

.HFFA69E{
  color: #D4C5E2;
}

.H2DE1FC{
  color: #2DE1FC;
}

.HFF7E6B{
  color: #FF7E6B;
}

.Hffd33c{
  color: #ffd33c;
}

.padding-top{
  padding-top: 100px;
  padding-bottom: 0;
  margin-bottom: -5rem; 
}

.margin-top{
  margin-top: 3rem;
}

.v-list-item{
  min-height: fit-content !important;
}

.no-margin{
  margin-bottom: 2px;
}

.aboutMe{
  align-content: center;
  text-align: justify !important;
  font-weight: 200;
}

.bottom{
  position:absolute;                  
  bottom:0;
}

.paper-title{
  margin-top: 5px;
  margin-left: 1px;
  font-weight: 100;
}

.img{
  max-width: 75%;
  max-height: 450px;
  margin: auto;
}

.link-website{
  text-decoration-line: underline;
  color: #FF5D73;
  text-align: end;
  font-size: 1.2vmax;
}

.link-website2{
  text-decoration-line: underline;
  color: #FF5D73;
  text-align: center;
  font-size: 1.2vmax;
}

.bold{
  font-weight: 900 !important;
}

.black-text{
  color: #464655;
}

.poster{
  max-width: 100%;
  max-height: 350px;
  margin: auto;
}

.poster-igem{
  max-width: 100%;
  max-height: 750px;
  margin: auto;
}

.black-text{
  color: #464655;
}

.less-margin{
  margin: auto;
}

.link{
  text-decoration: none;
  color: #FF5D73;
}

.margin{
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
}

.margin-about{
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.cv{
  text-align: justify;
}

@media only screen and (max-width: 800px) {
  .semi-title {
    margin-top: 3px;
    margin-left: 1px;
    font-size: 2.2vmax;
  }
  .cv-text{
    font-size: 2.2vmax;
  }
  .middle{
    padding-left: 10px;
  }
  .titlee{
    font-size: 2.5vmax;
  }
}

</style>
